import React from 'react';

import { Typography } from '@mui/material';
import { useTheme } from '@mui/styles';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

import FCList from 'components/FCList';
import Power from 'components/SvgComponents/icons/Power';
import globalMessages from 'translations/messages/global-messages';

function LogOut({ intl, onCloseDropdown, onClickLogout }) {
  const theme = useTheme();

  return (
    <div>
      <FCList.ListItemButton
        onClick={onClickLogout}
        onCloseDropdown={onCloseDropdown}
        aria-label={intl.formatMessage(globalMessages.sign_out)}
        title={intl.formatMessage(globalMessages.sign_out)}
      >
        <Power
          height={16}
          width={16}
          color={theme.palette.text.primary}
          style={{ marginRight: '8px' }}
        />

        <Typography variant="body">{intl.formatMessage(globalMessages.sign_out)}</Typography>
      </FCList.ListItemButton>
    </div>
  );
}

LogOut.propTypes = {
  intl: PropTypes.object.isRequired,
  onClickLogout: PropTypes.func,
  onCloseDropdown: PropTypes.func,
};

export default compose(injectIntl)(LogOut);
